import { render, staticRenderFns } from "./ProductAndModel.vue?vue&type=template&id=14fa3fd9&"
import script from "./ProductAndModel.vue?vue&type=script&lang=js&"
export * from "./ProductAndModel.vue?vue&type=script&lang=js&"
import style0 from "./ProductAndModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports